import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { resetPasswordForEmail } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const finalEmail = email.includes("@")
      ? email
      : `${email.trim()}@muqalabhoops.org`;
    try {
      await resetPasswordForEmail(finalEmail);
    } catch (err) {
      console.error("Reset request failed:", err);
      // Intentionally still show success below — don't reveal whether the email exists
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20">
      <div className="bg-white rounded-lg shadow-md p-8 dark:bg-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-center dark:text-white">
          Reset Your Password
        </h1>

        {sent ? (
          <div className="text-center space-y-4">
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded dark:bg-green-950/30 dark:border-green-800 dark:text-green-300">
              If an account exists for that email, a reset link is on its way.
              Check your inbox (and spam folder).
            </div>
            <Link
              to="/login"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              Back to login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block font-semibold mb-2 dark:text-white">
                Email
              </label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500
                                    focus:border-transparent dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                autoComplete="username"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold
                                hover:bg-orange-700 transition disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <p className="text-center text-sm">
              <Link
                to="/login"
                className="text-blue-600 dark:text-blue-400 underline"
              >
                Back to login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
